module.exports = __webpack_public_path__ + "static/media/input2_emp.9795499b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Design/img/input2_emp.png
// module id = 282
// module chunks = 0